export const MAX_KELOMPOK_MURID_MEMBER_COUNT = 10
